import { useTheme } from "@mui/material"
import { ToastContainer } from "react-toastify"
const ToastifyAlert = () => {
  const theme = useTheme()
  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme={theme?.palette?.mode}
      />
    </>
  )
}

export default ToastifyAlert
